import { preferencesAreLoaded } from '../brand/brandSelectors';
import { paymentStepPreConditions, paymentStepPostConditions } from './paymentStepSelectors';



const paymentStepConfig = {
    component: () => import('./PaymentStep'),
    flow: 'postBuy',
    hideCartLink: true,
    hidePromoBanner: true,
    isReady: state => (
        preferencesAreLoaded(state)
    ),
    preConditions: paymentStepPreConditions,
    postConditions: paymentStepPostConditions
};

export default paymentStepConfig;
